function runValidation(form, formfields, validationObject, schema, callback) {
    form.addEventListener("submit", function (e) {
        e.preventDefault();
        const values = { ...validationObject() }

        // Βγάζω όλα τα display block και τα κάνω hidden για να τρέξει ξανά το validation και να εμφανίσει όσα έχουν errors
        for (const fieldName in formfields) {
            if (formfields.hasOwnProperty(fieldName)) {
                if (form.querySelector(`.${fieldName}error`)) {
                    form.querySelector(`.${fieldName}error`).setAttribute('aria-hidden', true);
                }
            }
        }

        // Τρέχω το validation στο schema
        schema
            .validate(values, { abortEarly: false })
            .then(function () {
                // Email is valid
                callback(values)
            })
            .catch(function (error) {
                // Validation failed, show an error message
                // console.log({ ...error })

                // Normalize to an array of validation errors; fallback to the error itself
                const errorsArray = Array.isArray(error.inner) && error.inner.length ? error.inner : [error];

                for (const validationError of errorsArray) {
                    const fieldName = validationError.path; // Field name with error
                    const errorMessage = validationError.message || (validationError.errors && validationError.errors[0]) || 'Invalid value';

                    // Show or handle the error message for the specific field
                    const errorField = form.querySelector(`.${fieldName}error`);
                    if (errorField) {
                        errorField.setAttribute('aria-hidden', false);
                        errorField.innerHTML = errorMessage;
                    } else {
                        // If no specific error container exists, log it for debugging
                        console.warn('Error container not found for field:', fieldName, 'message:', errorMessage);
                    }
                }
            });
    });

}

function runValidationOnBlur(form, formfields, validationObject, schema) {
    // Attach blur event listener to each form field
    for (const fieldName in formfields) {
        if (formfields.hasOwnProperty(fieldName)) {
            const inputField = formfields[fieldName];


            // Add the appropriate event according to the input
            function addEventListener() {
                if (inputField.type == "text" || inputField.tagName.toLowerCase() === 'textarea') {
                    return "blur"
                }
                if (inputField.type == "checkbox") {
                    return "click"
                }
                if (inputField.tagName.toLowerCase() === 'select') {
                    return "change"
                }
            }

            inputField && inputField.addEventListener(addEventListener(), function () {
                // Hide any existing error messages for this field
                const errorField = form.querySelector(`.${fieldName}error`);
                errorField.setAttribute('aria-hidden', true);

                // Run validation for the specific field
                schema
                    .validateAt(fieldName, validationObject(), { abortEarly: false })
                    .then(function () {
                        // Field is valid
                    })
                    .catch(function (error) {
                        // Validation failed, show an error message for the specific field
                        const errorMessage = error.errors[0]; // Assuming only one error is shown at a time

                        errorField.setAttribute('aria-hidden', false);
                        errorField.innerHTML = errorMessage;
                    });
            });
        }
    }

    // Handle form submission as before
    form.addEventListener("submit", function (e) {
        e.preventDefault();

        // ... Rest of your form submission logic
    });
}

export { runValidationOnBlur, runValidation }
